'use client'

import { createContext } from '../../utils/context.ts'
import type { TestIds } from '../../utils/testing.ts'

export type AlertType = 'info' | 'notice' | 'warning' // add other types as needed (success, error, etc)

export type UseAlertProps = TestIds & {
  type: AlertType
}

export function useAlert({ dataTestId, dataTrackingId, type }: UseAlertProps) {
  return {
    dataTestId,
    dataTrackingId,
    type,
  }
}

export const [AlertProvider, useAlertContext] = createContext<
  ReturnType<typeof useAlert>
>({
  name: 'AlertContext',
})
